import type { Debug } from "@otto-ec/global-resources/debug";
import { kyFetch } from "./ky-fetch.ts";

type Logger = Debug<`benefit.${string}.fetch-retry`>;
type Counter = { value: number };

export interface FetchRetryArgs {
	url: string;
	namespace: string;
	timeout?: number;
	retryOptions: {
		limit: number;
		delay: number;
	};
	fetchOptions?: Exclude<RequestInit, "signal">;
}

export function fetchRetry(args: FetchRetryArgs) {
	return kyFetch(args);
}
